/** @format */

import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./store/store";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import App from "./app/js/App";
import Home from "./pages/home/Home.jsx";
import QuizOptions from "./pages/options/jsx/QuizOptions.jsx";
import QuestionCard from "./pages/questionCard/jsx/QuestionCard.jsx";
import Results from "./pages/results/jsx/Results.jsx";
import About from "./pages/about/About.jsx";
//import reportWebVitals from "./reportWebVitals.js";
import { optionsLoader } from "./loaders/optionsLoader.js";
import { questionsLoader } from "./loaders/questionsLoader";

import "./index.css";

const router = createBrowserRouter([
 {
  path: "/",
  element: <App />,
  HydrateFallback: <p>Loading…</p>,
  children: [
   { index: true, element: <Home /> },
   { path: "options", element: <QuizOptions />, loader: optionsLoader },
   { path: "quiz", element: <QuestionCard />, loader: questionsLoader },
   { path: "results", element: <Results /> },
   { path: "about", element: <About />},
  ],
 },
]);

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
 <React.StrictMode>
  <Provider store={store}>
   <RouterProvider router={router} />
  </Provider>
 </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
